/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_List_CredentialsInputs */

const es_tools_nexata_list_credentials = /** @type {(inputs: Tools_Nexata_List_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificando integraciones...`)
};

const en_tools_nexata_list_credentials = /** @type {(inputs: Tools_Nexata_List_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking integrations...`)
};

/**
* | output |
* | --- |
* | "Checking integrations..." |
*
* @param {Tools_Nexata_List_CredentialsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_list_credentials = /** @type {((inputs?: Tools_Nexata_List_CredentialsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_List_CredentialsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_list_credentials(inputs)
	return en_tools_nexata_list_credentials(inputs)
});
export { tools_nexata_list_credentials as "tools.nexata.list_credentials" }